export class SkillsFakeDb {
  public static skills = [
    {
      uuid: 'skill-1',
      name: 'First Aid',
      description: 'Basic First Aid certification'
    },
    {
      uuid: 'skill-2',
      name: 'RSA',
      description: 'Responsible Service of Alcohol'
    },
    {
      uuid: 'skill-3',
      name: 'Security License',
      description: 'Valid Security License'
    },
    {
      uuid: 'skill-4',
      name: 'Forklift Driving',
      description: 'Certified Forklift Driver'
    },
    {
      uuid: 'skill-5',
      name: 'Customer Service',
      description: 'Customer Service experience'
    },
    {
      uuid: 'skill-6',
      name: 'Working at Heights',
      description: 'Certified for working at heights above 2m'
    },
    {
      uuid: 'skill-7',
      name: 'White Card',
      description: 'Construction industry induction card'
    },
    {
      uuid: 'skill-8',
      name: 'Traffic Control',
      description: 'Traffic management and control certification'
    },
    {
      uuid: 'skill-9',
      name: 'Food Safety',
      description: 'Food handling and safety certification'
    },
    {
      uuid: 'skill-10',
      name: 'Barista',
      description: 'Coffee preparation and latte art'
    },
    {
      uuid: 'skill-11',
      name: 'Manual Handling',
      description: 'Safe lifting and manual handling training'
    },
    {
      uuid: 'skill-12',
      name: 'Fire Warden',
      description: 'Emergency fire warden certification'
    },
    {
      uuid: 'skill-13',
      name: 'Crowd Control',
      description: 'Crowd management and event safety'
    },
    {
      uuid: 'skill-14',
      name: 'Drivers License',
      description: 'Valid Australian drivers license'
    },
    {
      uuid: 'skill-15',
      name: 'Heavy Vehicle',
      description: 'Heavy rigid vehicle license'
    },
    {
      uuid: 'skill-16',
      name: 'Confined Spaces',
      description: 'Work in confined spaces certification'
    },
    {
      uuid: 'skill-17',
      name: 'Electrical Tagging',
      description: 'Test and tag electrical equipment'
    },
    {
      uuid: 'skill-18',
      name: 'CPR',
      description: 'Cardiopulmonary resuscitation certification'
    },
    {
      uuid: 'skill-19',
      name: 'RSG',
      description: 'Responsible Service of Gaming'
    },
    {
      uuid: 'skill-20',
      name: 'Bilingual - Spanish',
      description: 'Fluent in English and Spanish'
    }
  ];
}
